import { render, staticRenderFns } from "./counters.vue?vue&type=template&id=76572189"
import script from "./counters.vue?vue&type=script&lang=js"
export * from "./counters.vue?vue&type=script&lang=js"
import style0 from "./counters.vue?vue&type=style&index=0&id=76572189&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./counters.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports